import convertDetails from 'components/page/ConvertDetails/flow/reducer';
import FilterCriteria__REFACTORED from 'components/page/FilterCriteria__REFACTORED/flow/reducer';
import duplicates from 'components/page/FindDuplicates/flow/reducer';
import objectView from 'components/page/ObjectFilter/flow/reducer';
import accountOpportunities from 'components/page/SimpleTable/flow/reducer';
import taskDetails from 'components/page/TaskDetails/flow/reducer';
import multiDndFields from 'components/ui/MultiSelectDnD/flow/reducer';
import attachment from 'views/Attachment/flow/reducer';
import clientDetails from 'views/ClientDetails/flow/reducer';
import convertStatus from 'views/Conversion/flow/reducer';
import conversion from 'views/ConvertLeads/flow/reducer';
import dashboard from 'views/Dashboard/flow/reducer';
import globalSearch from 'views/GlobalSearch/flow/reducer';
import invoice from 'views/Invoice/flow/reducer';
import loginUser from 'views/LoginForm/flow/reducer';
import mergence from 'views/MergeLeads/flow/reducer';
import objectList from 'views/ObjectList/flow/reducer';
import objectShare from 'views/ObjectShare/flow/reducer';
import realTimeReport from 'views/RealTimeReport/flow/reducer';
import reportList from 'views/ReportList/flow/reducer';
import reportSetup from 'views/ReportSetup/flow/reducer';
import sharableObjects from 'views/Section_SharedTo/flow/reducer';
import task from 'views/Task/flow/reducer';
import metaData from './metaData/reducer';
import setup from './setupReducer';
import dashboardSettings from 'views/DashboardSettings/flow/reducer';

export default {
  loginUser,
  setup,
  multiDndFields,
  objectView,
  taskDetails,
  duplicates,
  mergence,
  objectList,
  globalSearch,
  objectShare,
  accountOpportunities,
  clientDetails,
  dashboard,
  conversion,
  task,
  convertDetails,
  convertStatus,
  invoice,
  FilterCriteria__REFACTORED,
  attachment,
  reportSetup,
  realTimeReport,
  reportList,
  sharableObjects,
  metaData,
  dashboardSettings
};



// WEBPACK FOOTER //
// ./src/store/pageReducer.js